import React, { Component } from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';

import styles from './styles';
import { DataTable } from 'components';

import Classifier from 'views/Classifier';
import { getAll } from './_actions';

// Inject reducers
import { store } from 'utils/store';
import { classifierList } from './_reducers';
store.injectReducer('classifierList', classifierList);


class ClassifierList extends Component {

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAll());
  }

  prepareTableColumns() {
    const { t } = this.props;
    const columns = [
      'ID',
      'LINK',
      t('Kodas'),
      t('Pavadinimas'),
      t('Priklauso kodui'),
      t('Klasifikatoriaus grupė'),
    ];

    return columns;
  }

  prepareTableData(records) {
    const data = _.map(records, record => {
      let row = [];

      row.push(record._id);
      row.push(`/classifier/${record._id}`);
      row.push(record.code);
      row.push(record.title);
      row.push(record.parentCode);
      row.push(record.group ? record.group.title : null);
      
      return row;
    });

    return data;
  }

  render() {
    const { classes, records, isLoading, t } = this.props;

    const columns = this.prepareTableColumns();
    const data = this.prepareTableData(records);

    return (
      <Classifier
        title={t('Klasifikatorius')}
        isLoading={isLoading}
        breadcrumbs={[
          { title: t('Administravimas') },
          { title: t('Klasifikatorius') }
        ]}
      >
        
        <div className={classes.content}>
          {!isLoading && (
            <DataTable 
              columns={columns}
              data={data}
              tableHeight={window.innerHeight > 900 ? '65vh' : '45vh'}
              createUrl="/classifier/create"
              // onDelete={(idx) => dispatch(deleteOne(companies[idx]._id))}
              // onDeleteBatch={(indexes) => dispatch(deleteBatch(_.map(indexes, (idx) => companies[idx]._id)))}
            />
          )}
        </div>

      </Classifier>
    );
  }
}

const mapStateToProps = ({ classifierList, dispatch }) => {
  return { 
    ...classifierList,
    dispatch,
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
  withTranslation(),
)(ClassifierList);